import { ThemeType } from "@/interfaces";
import { useUserStore } from "@/stores/userStore";
import { useEffect, useState } from "react";

const DEFAULT_THEME: ThemeType = {
  logo: null,
  favicon: null,
  primaryColor: "#1677ff",
  secondaryColor: "#0e172b",
};

export const useTheme = () => {
  const [theme, setTheme] = useState<ThemeType>(DEFAULT_THEME);
  const company = useUserStore((state) => state.currentCompany);

  useEffect(() => {
    if (company) {
      setTheme({
        logo: company.logoResource?.presignedUrl || null,
        favicon: company.faviconResource?.presignedUrl || null,
        primaryColor: company.primaryColor || DEFAULT_THEME.primaryColor,
        secondaryColor: company.secondaryColor || DEFAULT_THEME.secondaryColor,
      });
    } else {
      setTheme(DEFAULT_THEME);
    }
  }, [company]);

  return {
    theme,
  };
};
